module.exports = __webpack_public_path__ + "KaushanScript-Regular.bafd78da573962d22a81.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/KaushanScript-Regular.ttf
// module id = ../../../../../src/assets/font/KaushanScript-Regular.ttf
// module chunks = styles